/** Shared DotLottie settings so VetPets stay sharp on retina when scaled up. */
export const highQualityLottieProps = {
  autoplay: true,
  loop: true,
  useFrameInterpolation: true,
  layout: {
    fit: "contain" as const,
    align: [0.5, 0.5] as [number, number],
  },
  renderConfig: {
    autoResize: true,
    quality: 100,
    devicePixelRatio:
      typeof window === "undefined"
        ? 2
        : Math.min(3, Math.max(2, window.devicePixelRatio || 2)),
  },
};
